<template>
	<div class="wh">
		<div class="wh" v-loading="true"></div>
	</div>
</template>

<script>
	import configData from "@/assets/configData.js"
	export default{
		methods:{
			getaccess() {
				let access_token = this.$route.query.access_token;

				// access_token = "b1576524baf493a0e95cb0188995c509";

				localStorage.setItem("access_token",access_token);
				if(access_token) {
					localStorage.setItem("access_token",access_token);
				}else {
					access_token = localStorage.getItem("access_token")
				}				
				this.api.access({
					access_token:access_token
				}).then((da) => {
					if(da.result == 0){
						localStorage.setItem("access",JSON.stringify(da.data));
						let url = (configData.url?configData.url:{});
						for(var i = 0; i<da.data.menu_banner.length;i++){
							if(da.data.menu_banner[i].child.length != 0){
								this.router.push({path: url[da.data.menu_banner[i].child[0].id]});
								break;
							}
						}
					}
				})
			},
			getQueryString(name) { 
				var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
				var r = window.location.search.substr(1).match(reg); 
				if (r != null) return unescape(r[2]); 
				return null; 
			},
			
		},
		mounted(){
			this.getaccess();
		}
	}
</script>

<style>
	
</style>
